import { Chip } from "framework7-react";
import { memo } from "react";

import { CategoryEnum } from "@/generated/graphql/graphql";
import { useUserCategory } from "@/hooks/useUserCategory";

import { ColorCircle } from "./ColorCircle";

type CategoryChipProps = { categoryKey: CategoryEnum };

export const CategoryChip = memo(CategoryChipComponent);

function CategoryChipComponent({ categoryKey }: CategoryChipProps) {
  const userCategory = useUserCategory(categoryKey);

  return (
    <Chip
      style={{ backgroundColor: "unset" }}
      text={userCategory?.name}
    >
      <div slot="media">
        <ColorCircle
          color={userCategory?.color}
          size={24}
        />
      </div>
    </Chip>
  );
}
